module.exports = __webpack_public_path__ + "static/media/hover-linkedin.90d7e64e.svg";